import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    ServicePatternGridObject, ServicePatternObject,
} from '@libs/types/src/services/object-type/service/service-pattern.object';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { ServiceService } from '../../../../../services/service.service';
import { Observable } from 'rxjs';
import { selectCurrentServiceId } from '../../../store/person/person.selectors';
import { map } from 'rxjs/operators';
import { ServicePatternDocumentUsageEnum } from '@libs/types/src/services/enum/service-pattern-document-usage.enum';

interface State {
    servicePatterns: ServicePatternGridObject | null,
}

const defaultState: State = {
    servicePatterns: null,
};

@Injectable()
export class BeforePrintDialogStore extends ComponentStoreFactory<State> {

    serviceId$: Observable<number | null> = this.globalStore!.select(selectCurrentServiceId);
    headers$ = (this.data.servicePatterns$.gridItems() as  Observable<ServicePatternObject[]>)
        .pipe(map((items: ServicePatternObject[]) =>
                items.filter((item) => item.usage === ServicePatternDocumentUsageEnum.header),
        ));
    footers$ = (this.data.servicePatterns$.gridItems() as  Observable<ServicePatternObject[]>)
        .pipe(map((items: ServicePatternObject[]) =>
                items.filter((item) => item.usage === ServicePatternDocumentUsageEnum.footer),
        ));

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
